window.addEventListener("DOMContentLoaded", () => {
	const mainTabs = document.querySelectorAll('.b-needs__tab')
	const subTabs = document.querySelectorAll('.b-needs__subTab')
	const groupContainer = document.querySelectorAll('.b-needs__groupContainer')

	const drawVerticalGroupLine = (item, elemWrapper) => {
		const firstChildRect = item.children[0].getBoundingClientRect()
		const firstContentRect = item.children[0].querySelector('.b-needs__contentSecond').getBoundingClientRect()
		const lastChildRect = item.children[item.children.length - 1].getBoundingClientRect()
		const lastContentRect = item.children[item.children.length - 1].querySelector('.b-needs__contentSecond').getBoundingClientRect()
		itemRect = item.getBoundingClientRect()

		console.log(firstContentRect, lastContentRect)

		const elemWrapperHeight = lastContentRect.y - firstContentRect.y - 40

		console.log(elemWrapperHeight)
		elemWrapper.style.height = `${elemWrapperHeight}px`
	}

	const openCurrentMainTab = (mainTab, i) => {
		const currentSubWrapper = document.querySelectorAll('.b-needs__subTabsWrapper')[i]
		const subTab = currentSubWrapper.children[0]
		const contentId = subTab.dataset.id
		const blockContent = document.getElementById(contentId)

		subTab.classList.add('active')
		blockContent.classList.add('active')
		mainTab.classList.add('active')
		currentSubWrapper.classList.add('active')
	}

	const closePrevTab = () => {
		const prevTab = document.querySelector('.b-needs__tab.active')
		const prevSubTab = document.querySelector('.b-needs__subTab.active')
		const prevSubWrapper = document.querySelector('.b-needs__subTabsWrapper.active')
		const prevContent = document.querySelector('.b-needs__subTabsContentWrapper.active')
		
		prevContent.classList.remove('active')
		prevSubWrapper.classList.remove('active')
		prevTab.classList.remove('active')
		prevSubTab.classList.remove('active')
	}

	if(mainTabs) {
		mainTabs.forEach((mainTab, i) => {
			mainTab.addEventListener('click', () => {
				closePrevTab()
				openCurrentMainTab(mainTab, i)

				if(groupContainer) {
					groupContainer.forEach(item => {
						const elemWrapper = item.querySelector('.b-needs__elemWrapper')
						drawVerticalGroupLine(item, elemWrapper)
					})
				}
			})
		})
	}

	const openCurrentSubTab = (subTab) => {
		const contentIndex = subTab.dataset.index
		const currentContent = document.querySelectorAll('.b-needs__subTabsContentWrapper')[contentIndex]

		subTab.classList.add('active')
		currentContent.classList.add('active')
	}

	const closePrevSubTab = () => {
		const prevSubTab = document.querySelector('.b-needs__subTab.active')
		const prevContent =  document.querySelector('.b-needs__subTabsContentWrapper.active')

		prevSubTab.classList.remove('active')
		prevContent.classList.remove('active')
	}

	if(subTabs) {
		subTabs.forEach(subTab => {
			subTab.addEventListener('click', () => {
				closePrevSubTab()
				openCurrentSubTab(subTab)

				if(groupContainer) {
					groupContainer.forEach(item => {
						const elemWrapper = item.querySelector('.b-needs__elemWrapper')
						drawVerticalGroupLine(item, elemWrapper)
					})
				}
			})
		})
	}

	if(groupContainer) {
		groupContainer.forEach(item => {
			const elemWrapper = item.querySelector('.b-needs__elemWrapper')
			window.addEventListener('resize', () => {
				drawVerticalGroupLine(item, elemWrapper)
			})
		})
	}
})